import { Type } from 'class-transformer'

import { StartNodeData } from '../../Editor/StartNode/StartNode'
import { HttpRequestNodeData } from "../Additionally/HttpRequest/logic/HttpRequestNode";
import { RunFlowNodeData } from '../Additionally/RunFlow/logic/RunFlowNode'
import { CheckSubscriptionNodeData } from '../Branching/CheckSubscriptionNode/logic/CheckSubscriptionNode'
import { ConditionsNodeData } from '../Branching/ConditionsNode/logic/ConditionsNode'
import { DelayNodeData } from '../Branching/DelayNode/logic/DelayNode'
import { RandomizerNodeData } from '../Branching/RandomizerNode/logic/RandomizerNode'
import { ActionNodeData } from '../Communications/Action/logic/ActionNode'
import { EditLastMessageNodeData } from '../Communications/EditLastMessage/logic/EditLastMessageNode'
import { ForwardMessageNodeData } from '../Communications/ForwardMessage/logic/ForwardMessageNode'
import { SendInvoiceNodeData } from '../Communications/SendInvoice/logic/SendInvoiceNode'
import { SendMessageNodeData } from '../Communications/SendMessage/logic/SendMessageNode'
import { CheckLimitedSubscriptionNodeData } from '../Subscription/CheclLimitedSubscription/logic/CheckLimitedSubscriptionNode'
import { CreateLimitedSubscriptionNodeData } from '../Subscription/CreateLimitedSubscription/logic/CreateLimitedSubscription'
import { InfoLimitedSubscriptionNodeData } from '../Subscription/InfoLimitedSubscription/logic/InfoLimitedSubscriptionNode'
import { NodeTypes } from '../index'
import { BaseNodeModelData } from './BaseNodeDataModel'

export class FlowNodesModelsFactory {
  static ModelsFactories: Array<{name: NodeTypes | string, value: typeof BaseNodeModelData}> = [
    { name: NodeTypes.Start, value: StartNodeData },
    { name: NodeTypes.Randomizer, value: RandomizerNodeData },
    { name: NodeTypes.Action, value: ActionNodeData },
    { name: NodeTypes.SendMessage, value: SendMessageNodeData },
    { name: NodeTypes.SendInvoice, value: SendInvoiceNodeData },
    { name: NodeTypes.EditLastMessage, value: EditLastMessageNodeData },
    { name: NodeTypes.ForwardMessage, value: ForwardMessageNodeData },
    { name: NodeTypes.Delay, value: DelayNodeData },
    { name: NodeTypes.CheckSubscription, value: CheckSubscriptionNodeData },
    { name: NodeTypes.CheckLimitedSubscription, value: CheckLimitedSubscriptionNodeData },
    { name: NodeTypes.CreateLimitedSubscription, value: CreateLimitedSubscriptionNodeData },
    { name: NodeTypes.InfoLimitedSubscription, value: InfoLimitedSubscriptionNodeData },
    { name: NodeTypes.RunFlow, value: RunFlowNodeData },
    { name: NodeTypes.Conditions, value: ConditionsNodeData },
    { name: NodeTypes.HttpRequest, value: HttpRequestNodeData },
  ]

  static SetModelFactory(name: string, value: typeof BaseNodeModelData): void {
    FlowNodesModelsFactory.ModelsFactories.push({ name, value })
  }
}

export class BaseNodeModel {
  @Type(() => BaseNodeModelData, {
    keepDiscriminatorProperty: true,
    discriminator: {
      property: 'type',
      subTypes: FlowNodesModelsFactory.ModelsFactories
    }
  })
  data!: BaseNodeModelData
  color!: null | string
  x!: number
  y!:number
  input?: number
  output?: number
}
